import Skeleton from './motion/Skeleton';

/**
 * The loading indicator: shimmering placeholder bars, with the label (default
 * "Loading…") kept for screen readers. A drop-in for
 * `<div className="loading">Loading…</div>`.
 */
export default function Loader({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="loading" role="status">
      <Skeleton />
      <span className="visually-hidden">{label}</span>
    </div>
  );
}
